import { imgLakay1, imgLakay2, imgLakay3, imgLakay4, imgLakay5, imgLakay6, imgLakay7, imgLakay8, imgLakay9, imgLakay10, imgLakay11, imgLakay12, imgLakay13, imgLakay14, imgLakay15, imgLakay16, imgLakay17, imgLakay18, imgLakay19, imgLakay20, imgLakay21, imgLakay22, imgLakay23, imgLakay24, imgLakay25, imgLakay26, imgLakay27, imgLakay28, imgLakay29, imgLakay30, imgLakay31, imgLakay32, imgLakay33, imgLakay34, imgLakay35, imgLakay36, imgLakay37, imgLakay38, imgLakay39, imgLakay40, shop_00, shop_01, shop_02, shop_03, shop_04, shop_05, shop_06, shop_07, shop_08, shop_09, shop_10, shop_11, shop_12, shop_13, shop_14, shop_15, shop_16, shop_17, shop_18, shop_19, shop_20, shop_21, shop_22, shop_23, shop_24, shop_25 } from "../defaultPromo/legacyPromoSources";
import { getPublicImageFiles } from '../defaultPromo/apiSwiperImageFiles';
import { selectImages } from '../defaultPromo/imageSelection';
import { useEffect, useState } from 'react';


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["sliderElakayImage"]?.[key] || fallback;

// /Users/yvesoxilus/Documents/App-ServerWeb-Elakay/front_elakay/src/includes/slider/shopImages/shop_00.png
// front_elakay/src/includes/slider/shopImages/shop_00.png

const SliderElakay = (infoSource, { enabled = true } = {}) => {
  __setElakayInfoSource(infoSource);


  const [randomImages, setRandomImages] = useState([]);
  const [shopImages, setshopImages] = useState([]);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
 const imgLakayShop = [
  { name: __elakayText("t001", "shop_00"), link: shop_00 },
  { name: __elakayText("t002", "shop_01"), link: shop_01 },
  { name: __elakayText("t003", "shop_02"), link: shop_02 },
  { name: __elakayText("t004", "shop_03"), link: shop_03 },
  { name: __elakayText("t005", "shop_04"), link: shop_04 },
  { name: __elakayText("t006", "shop_05"), link: shop_05 },
  { name: __elakayText("t007", "shop_06"), link: shop_06 },
  { name: __elakayText("t008", "shop_07"), link: shop_07 },
  { name: __elakayText("t009", "shop_08"), link: shop_08 },
  { name: __elakayText("t010", "shop_09"), link: shop_09 },
  { name: __elakayText("t011", "shop_10"), link: shop_10 },
  { name: __elakayText("t012", "shop_11"), link: shop_11 },
  { name: __elakayText("t013", "shop_12"), link: shop_12 },
  { name: __elakayText("t014", "shop_13"), link: shop_13 },
  { name: __elakayText("t015", "shop_14"), link: shop_14 },
  { name: __elakayText("t016", "shop_15"), link: shop_15 },
  { name: __elakayText("t017", "shop_16"), link: shop_16 },
  { name: __elakayText("t018", "shop_17"), link: shop_17 },
  { name: __elakayText("t019", "shop_18"), link: shop_18 },
  { name: __elakayText("t020", "shop_19"), link: shop_19 },
  { name: __elakayText("t021", "shop_20"), link: shop_20 },
  { name: __elakayText("t022", "shop_21"), link: shop_21 },
  { name: __elakayText("t023", "shop_22"), link: shop_22 },
  { name: __elakayText("t024", "shop_23"), link: shop_23 },
  { name: __elakayText("t025", "shop_24"), link: shop_24 },
  { name: __elakayText("t026", "shop_25"), link: shop_25 },
];

const imgLakay = [
    { name: __elakayText("t027", "imgLakay1"), link: imgLakay1 },
    { name: __elakayText("t028", "imgLakay2"), link: imgLakay2 },
    { name: __elakayText("t029", "imgLakay3"), link: imgLakay3 },
    { name: __elakayText("t030", "imgLakay4"), link: imgLakay4 },
    { name: __elakayText("t031", "imgLakay5"), link: imgLakay5 },
    { name: __elakayText("t032", "imgLakay6"), link: imgLakay6 },
    { name: __elakayText("t033", "imgLakay7"), link: imgLakay7 },
    { name: __elakayText("t034", "imgLakay8"), link: imgLakay8 },
    { name: __elakayText("t035", "imgLakay9"), link: imgLakay9 },
    { name: __elakayText("t036", "imgLakay10"), link: imgLakay10 },
    { name: __elakayText("t037", "imgLakay11"), link: imgLakay11 },
    { name: __elakayText("t038", "imgLakay12"), link: imgLakay12 },
    { name: __elakayText("t039", "imgLakay13"), link: imgLakay13 },
    { name: __elakayText("t040", "imgLakay14"), link: imgLakay14 },
    { name: __elakayText("t041", "imgLakay15"), link: imgLakay15 },
    { name: __elakayText("t042", "imgLakay16"), link: imgLakay16 },
    { name: __elakayText("t043", "imgLakay17"), link: imgLakay17 },
    { name: __elakayText("t044", "imgLakay18"), link: imgLakay18 },
    { name: __elakayText("t045", "imgLakay19"), link: imgLakay19 },
    { name: __elakayText("t046", "imgLakay20"), link: imgLakay20 },
    { name: __elakayText("t047", "imgLakay21"), link: imgLakay21 },
    { name: __elakayText("t048", "imgLakay22"), link: imgLakay22 },
    { name: __elakayText("t049", "imgLakay23"), link: imgLakay23 },
    { name: __elakayText("t050", "imgLakay24"), link: imgLakay24 },
    { name: __elakayText("t051", "imgLakay25"), link: imgLakay25 },
    { name: __elakayText("t052", "imgLakay26"), link: imgLakay26 },
    { name: __elakayText("t053", "imgLakay27"), link: imgLakay27 },
    { name: __elakayText("t054", "imgLakay28"), link: imgLakay28 },
    { name: __elakayText("t055", "imgLakay29"), link: imgLakay29 },
    { name: __elakayText("t056", "imgLakay30"), link: imgLakay30 },
    { name: __elakayText("t057", "imgLakay31"), link: imgLakay31 },
    { name: __elakayText("t058", "imgLakay32"), link: imgLakay32 },
    { name: __elakayText("t059", "imgLakay33"), link: imgLakay33 },
    { name: __elakayText("t060", "imgLakay34"), link: imgLakay34 },
    { name: __elakayText("t061", "imgLakay35"), link: imgLakay35 },
    { name: __elakayText("t062", "imgLakay36"), link: imgLakay36 },
    { name: __elakayText("t063", "imgLakay37"), link: imgLakay37 },
    { name: __elakayText("t064", "imgLakay38"), link: imgLakay38 },
    { name: __elakayText("t065", "imgLakay39"), link: imgLakay39 },
    { name: __elakayText("t066", "imgLakay40"), link: imgLakay40 },
  ]

    // Fonction pour tirer 5 images au hasard
    const getRandomImages = (images, count = 5) => {
      const shuffled = [...images].sort(() => 0.5 - Math.random());
      return shuffled.slice(0, count);
    };

    // Définir les images dans le state
    setRandomImages(getRandomImages(imgLakay, 4));
    setshopImages(getRandomImages(imgLakayShop, 3));
    // The persistent pool respects disabled historical resources and replacements.
    getPublicImageFiles('shops').then((result) => {
      if (cancelled || !result.success) return;
      const picked = selectImages(result.images || [], result.settings?.slideCount || 3, 'elakay-legacy-shop-images');
      setshopImages(picked.map((image) => ({ name: image.name, link: image.url })));
    });
    getPublicImageFiles('categories').then((result) => {
      if (cancelled || !result.success || !result.settings?.enabled) return;
      const picked = selectImages(result.images || [], result.settings.slideCount || 4, 'elakay-legacy-category-images');
      setRandomImages(picked.map((image) => ({ name: image.name, link: image.url })));
    });
    return () => { cancelled = true; };
  }, [enabled]);


  return {randomImages, shopImages};
};

export default SliderElakay;

// Historical bundled banners, listed for the one-time import into the
// Default Promotional Swipers image library (Swiper Manager -> Default
// Promotional Swipers -> "Import historical banners"). legacyKey makes the
// import idempotent; the files themselves stay in the repository.
export { LEGACY_PROMO_IMAGE_SOURCES } from "../defaultPromo/legacyPromoSources";
